import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import AllTransactions from './AllTransactions';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, error, message, transactions,
  } = state.transaction;
  return {
    isLoading,
    error,
    message,
    transactions,
  };
}

const Styled = withStyles(styles)(AllTransactions);

export default connect(
  mapStateToProps,
)(Styled);
